import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Provider from 'store/index';
import preloadImages from 'helpers/preload-images';
import { CUSTOM_OPSIONS_PARAM_KEY } from 'config-app/config';
import Home from 'components/Container/index';
import { Page1 } from './components/Single';
import { APP_ROOT_ID } from 'config-app/config';

const App = () => {
  const [appData, setAppData] = useState(null);
  const [restoreData, setRestoreData] = useState(null);
  useEffect(() => {
    // HTML からデータを取得
    const json = window.CB;
    const product = window.product;

    if (json && json.locale) {
      setAppData(json);

      // URL パラメータから選択状態を復元
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const query = params.get(CUSTOM_OPSIONS_PARAM_KEY);
      const restore = query ? query.split(',') : null;
      setRestoreData(restore);
      // 画像のプリロード
      preloadImages(window.CB.images);
    } else if (product) {
      ReactDOM.render(<Page1 />,document.getElementById(APP_ROOT_ID))
    } else {
      console.log("error");
    }
    document.getElementById('custom-bottle-root').removeAttribute('style');
  }, []);

  return (
    <>
      {appData && (
        <Provider data={appData} restore={restoreData}>
          <Home />
        </Provider>
      )}
    </>
  );
};

export default App;
